<script setup>
</script>

<template>
  <nav>
    <a href="/">
      <span class="css__title">鷲組!!</span>
    </a>
    <div>東北楽天ゴールデンイーグルスファン集いの場</div>
  </nav>
</template>

<style scoped>
.css__title {
  margin: 0;
  font-weight: bolder;
  font-size: 2.5em;
}

a {
  display: inline-block;
  color: #383c3c;
  text-decoration: none;
}

ul {
  display: flex;
  padding: 0;
}

li {
  display: inline-block;
  flex: auto;
  padding: 0;
  width: 80px;
  list-style: none;
}

.text {
  font-size: .9em;
}
</style>